// removed by extract-text-webpack-plugin
module.exports = {"container":"_1yTTgtG","link":"_1z75khH","image":"_30Ntdiu","label":"RYZoujz","label__sale":"_1EDIGUs"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/SquareItem/index.css
// module id = ./template/components/Navigation/SideNavigationContainer/SquareItem/index.css
// module chunks = client.sitechrome